(function () {
  'use strict';

  if (window.__uvAnalyticsInitialized) return;
  window.__uvAnalyticsInitialized = true;

  var STORAGE_KEY = 'uv_nudge_variant';
  var CITY_CACHE_KEY = 'pilgrim_uv_city_v1';
  var IP_API = 'https://webengagebackup.discoverpilgrim.com/polls/get_client_ip?format=json';
  var ROLLOUT_PERCENT = 50;
  var CONTROL_STYLE_ID = 'uv-nudge-control-hide-style';
  var CART_WIDGET_SELECTOR = '#cart-uv-nudge';
  var PDP_WIDGET_SELECTOR = '[data-pdp-uv-index]';
  var CART_DRAWER_SELECTOR = 'cart-drawer#mini-cart';
  var CART_ADD_BUTTON_SELECTOR = '#cart-uv-nudge .uv-nudge__add-btn';
  var UV_WIDGET_LINE_ITEM_PROPERTY_KEY = '_uv_widget';
  var UV_WIDGET_LINE_ITEM_PROPERTY_VALUE = 'true';
  var UV_CART_PRODUCT_ID = '9417536995557';
  var ASSIGNMENT_DATALAYER_EVENT = 'uv_nudge_assignment';
  var ELIGIBLE_CITY_MAP = {
    mumbai: true,
    pune: true,
    delhi: true,
    'new delhi': true
  };

  var state = {
    pendingEvents: [],
    flushTimer: null,
    runtimeVariant: null,
    userCity: '',
    isCityEligible: false,
    pdpViewedKeys: {},
    cartDrawerViewFiredForCurrentOpen: false,
    cartDrawerLastOpenState: false
  };

  function getMoengageClient() {
    if (window.Moengage && typeof window.Moengage.track_event === 'function') return window.Moengage;
    if (window.MoEngage && typeof window.MoEngage.track_event === 'function') return window.MoEngage;
    if (typeof Moengage !== 'undefined' && Moengage && typeof Moengage.track_event === 'function') return Moengage;
    if (typeof MoEngage !== 'undefined' && MoEngage && typeof MoEngage.track_event === 'function') return MoEngage;
    return null;
  }

  function sendEventWithClient(client, eventName, payload) {
    if (!client || !eventName) return false;

    if (typeof client.track_event === 'function') {
      client.track_event(eventName, payload || {});
      return true;
    }

    if (typeof client.trackEvent === 'function') {
      client.trackEvent(eventName, payload || {});
      return true;
    }

    return false;
  }

  function flushPendingEvents() {
    var client = getMoengageClient();
    if (!client || !state.pendingEvents.length) return;

    var queue = state.pendingEvents.slice();
    state.pendingEvents = [];

    for (var i = 0; i < queue.length; i++) {
      sendEventWithClient(client, queue[i].name, queue[i].payload);
    }
  }

  function ensureFlushTimer() {
    if (state.flushTimer) return;
    state.flushTimer = setInterval(flushPendingEvents, 1500);
  }

  function trackMoengageEvent(eventName, payload) {
    if (!eventName) return;

    try {
      var client = getMoengageClient();
      if (client) {
        sendEventWithClient(client, eventName, payload || {});
        return;
      }

      state.pendingEvents.push({ name: eventName, payload: payload || {} });
      if (state.pendingEvents.length > 100) state.pendingEvents.shift();
      ensureFlushTimer();
    } catch (error) {
      console.warn('UV analytics error:', error);
    }
  }

  function getLocalStorageValue(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function setLocalStorageValue(key, value) {
    state.runtimeVariant = value;
    try {
      if (window.localStorage) window.localStorage.setItem(key, value);
    } catch (error) {}
  }

  function removeLocalStorageValue(key) {
    state.runtimeVariant = null;
    try {
      if (window.localStorage) window.localStorage.removeItem(key);
    } catch (error) {}
  }

  function normalizeCityKey(city) {
    return String(city || '').trim().toLowerCase();
  }

  function isEligibleCity(city) {
    return !!ELIGIBLE_CITY_MAP[normalizeCityKey(city)];
  }

  function getSessionStorageValue(key) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function setSessionStorageValue(key, value) {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  async function getCity() {
    var cached = getSessionStorageValue(CITY_CACHE_KEY);
    if (cached !== null) return normalizeCityKey(cached);

    try {
      var response = await fetch(IP_API, { credentials: 'omit' });
      var data = await response.json();
      var city = normalizeCityKey(data && data.city);
      setSessionStorageValue(CITY_CACHE_KEY, city);
      return city;
    } catch (error) {
      setSessionStorageValue(CITY_CACHE_KEY, '');
      return '';
    }
  }

  function getAssignedVariant() {
    var stored = getLocalStorageValue(STORAGE_KEY);
    if (stored === 'test' || stored === 'control') return stored;
    return state.runtimeVariant;
  }

  function pushAssignmentToDataLayer(assigned) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: ASSIGNMENT_DATALAYER_EVENT,
        uv_nudge_variant: assigned
      });
    } catch (error) {
      console.warn('UV analytics error:', error);
    }
  }

  function fireAssignmentEvent(assigned, percentage) {
    trackMoengageEvent('UV Nudge Assigned', {
      variant: assigned,
      rollout_percent: percentage
    });
    pushAssignmentToDataLayer(assigned);
  }

  function isInUVTestGroup(percentage) {
    if (!state.isCityEligible) return false;

    var existing = getAssignedVariant();
    if (existing === 'test' || existing === 'control') return existing === 'test';

    var roll = Math.random() * 100;
    var assigned = roll < percentage ? 'test' : 'control';
    setLocalStorageValue(STORAGE_KEY, assigned);
    fireAssignmentEvent(assigned, percentage);
    return assigned === 'test';
  }

  function getVariantForPayload() {
    var variant = getAssignedVariant();
    return variant === 'test' || variant === 'control' ? variant : 'unknown';
  }

  function parseUvLevel(summaryText) {
    var text = String(summaryText || '');
    var match = text.match(/\(([^)]+)\)/);
    if (match && match[1]) return match[1].trim();
    return '';
  }

  function getText(root, selector) {
    if (!root) return '';
    var element = root.querySelector(selector);
    return element ? String(element.textContent || '').trim() : '';
  }

  function isElementVisible(element) {
    if (!element) return false;
    if (element.hidden) return false;

    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) return false;

    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function applyControlGroupHiding() {
    if (document.getElementById(CONTROL_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = CONTROL_STYLE_ID;
    style.textContent = ''
      + CART_WIDGET_SELECTOR + '{display:none !important;}'
      + PDP_WIDGET_SELECTOR + '{display:none !important;}';
    document.head.appendChild(style);
  }

  function getPdpEventPayload(section) {
    var variant = getVariantForPayload();
    var productId = section.getAttribute('data-product-id') || '';
    var city = getText(section, '[data-uv-city]');
    var uvSummary = getText(section, '[data-uv-summary]');
    var uvLevel = parseUvLevel(uvSummary);

    return {
      variant: variant,
      product_id: productId,
      uv_level: uvLevel,
      city: city
    };
  }

  function getCartEventPayload() {
    var cartWidget = document.querySelector(CART_WIDGET_SELECTOR);
    var city = getText(cartWidget, '.uv-nudge__city-name');
    var uvSummary = getText(cartWidget, '.uv-nudge__uv-summary');
    var uvLevel = parseUvLevel(uvSummary);

    return {
      variant: getVariantForPayload(),
      uv_level: uvLevel,
      city: city
    };
  }

  function firePdpViewedIfReady(section) {
    if (!section || !isElementVisible(section) || !isInUVTestGroup(ROLLOUT_PERCENT)) return;

    var key = section.getAttribute('id') || section.getAttribute('data-block-id') || 'pdp-uv-index';
    if (state.pdpViewedKeys[key]) return;

    var payload = getPdpEventPayload(section);
    if (!payload.city && !payload.uv_level) return;

    state.pdpViewedKeys[key] = true;
    trackMoengageEvent('UV Index Widget Viewed', payload);
  }

  function setupPdpViewedTracking() {
    var sections = document.querySelectorAll(PDP_WIDGET_SELECTOR);
    if (!sections.length) return;

    var intersectionObserver = null;
    if ('IntersectionObserver' in window) {
      intersectionObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) firePdpViewedIfReady(entries[i].target);
        }
      }, { threshold: 0.15 });
    }

    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];

      if (intersectionObserver) {
        intersectionObserver.observe(section);
      } else {
        setTimeout((function (el) {
          return function () { firePdpViewedIfReady(el); };
        })(section), 800);
      }

      var mutationObserver = new MutationObserver((function (el) {
        return function () { firePdpViewedIfReady(el); };
      })(section));

      mutationObserver.observe(section, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true
      });

      setTimeout((function (el) {
        return function () { firePdpViewedIfReady(el); };
      })(section), 1500);
    }
  }

  function getCartDrawer() {
    return document.querySelector(CART_DRAWER_SELECTOR) || document.querySelector('cart-drawer');
  }

  function fireCartWidgetViewedForCurrentOpen() {
    if (!isInUVTestGroup(ROLLOUT_PERCENT)) return;
    if (state.cartDrawerViewFiredForCurrentOpen) return;

    var drawer = getCartDrawer();
    if (!drawer || !drawer.hasAttribute('open')) return;

    var widget = document.querySelector(CART_WIDGET_SELECTOR);
    if (!isElementVisible(widget)) return;

    state.cartDrawerViewFiredForCurrentOpen = true;
    trackMoengageEvent('UV Cart Widget Viewed', getCartEventPayload());
  }

  function handleCartDrawerStateChange(isOpen) {
    if (isOpen && !state.cartDrawerLastOpenState) {
      state.cartDrawerViewFiredForCurrentOpen = false;
      setTimeout(fireCartWidgetViewedForCurrentOpen, 120);
      setTimeout(fireCartWidgetViewedForCurrentOpen, 400);
    }

    if (!isOpen) {
      state.cartDrawerViewFiredForCurrentOpen = false;
    }

    state.cartDrawerLastOpenState = isOpen;
  }

  function setupCartViewedTracking() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    handleCartDrawerStateChange(drawer.hasAttribute('open'));

    var drawerObserver = new MutationObserver(function () {
      handleCartDrawerStateChange(drawer.hasAttribute('open'));
    });
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });

    document.documentElement.addEventListener('cart:refresh', function () {
      setTimeout(fireCartWidgetViewedForCurrentOpen, 80);
    });
  }

  function setupCartAddToCartTracking() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest(CART_ADD_BUTTON_SELECTOR);
      if (!button || !isInUVTestGroup(ROLLOUT_PERCENT)) return;

      var form = button.closest('.shopify-product-form');
      if (form) {
        var propertyInputSelector = '[name="[properties[' + UV_WIDGET_LINE_ITEM_PROPERTY_KEY + ']]"]';
        if (!form.querySelector(propertyInputSelector)) {
          var propertyInput = document.createElement('input');
          propertyInput.setAttribute('type', 'hidden');
          propertyInput.setAttribute('name', '[properties[' + UV_WIDGET_LINE_ITEM_PROPERTY_KEY + ']]');
          propertyInput.value = UV_WIDGET_LINE_ITEM_PROPERTY_VALUE;
          form.appendChild(propertyInput);
        }
      }

      var payload = getCartEventPayload();
      payload.product_id = UV_CART_PRODUCT_ID;

      trackMoengageEvent('UV Cart Widget Add to Cart', payload);
    }, true);
  }

  async function init() {
    state.userCity = await getCity();
    state.isCityEligible = isEligibleCity(state.userCity);

    if (!state.isCityEligible) {
      removeLocalStorageValue(STORAGE_KEY);
      applyControlGroupHiding();
      return;
    }

    var inTestGroup = isInUVTestGroup(ROLLOUT_PERCENT);
    if (!inTestGroup) applyControlGroupHiding();

    setupPdpViewedTracking();
    setupCartViewedTracking();
    setupCartAddToCartTracking();
    ensureFlushTimer();
    flushPendingEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
